import { DeferComponents } from './components/DeferComponents';
import { DeferClasses } from './classes/DeferClasses';
import { actionRegistry, skeletonRegistry } from '../../registry/Registry';
import { DeferActions } from './actions/DeferActions';
import { DeferSkeletons } from './skeletons/DeferSkeletons';
export class PackageDefer {
    parent;
    classes = new DeferClasses();
    components = new DeferComponents();
    actions = new DeferActions(actionRegistry);
    skeletons = new DeferSkeletons(skeletonRegistry);
}
